import "../../components/welcomeScreen/welcomeWizard.scss";

import PropTypes from "prop-types";
import React from "react";

import FormCheckbox from "../../components/form/FormCheckbox";
import FormDropdown from "../../components/form/FormDropdown";
import ModalBlock from "../../components/modal/ModalBlock";
import ModalBody from "../../components/modal/ModalBody";
import ModalCheckboxGrid from "../../components/modal/ModalCheckboxGrid";
import ModalField from "../../components/modal/ModalField";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalRow from "../../components/modal/ModalRow";
import ModalTabContent from "../../components/modal/ModalTabContent";
import SyncCustomFieldOptions from "../../constants/SyncCustomFieldOptions";
import syncFieldTypes from "../../constants/syncFieldTypes";
import SyncTypeOptions from "../../constants/SyncTypeOptions";
import typeSelectors from "../../modules/definition/types/selectors";
import { syncSelectors } from "../../modules/sync";
import { syncSettingsOperations, syncSettingsSelectors } from "../../modules/sync/settings";
import selectors from "./selectors";

const mapToOptions = [
  {
    value: 1,
    label: "Keywords",
    description: "Each related item will be added as a keyword."
  },
  {
    value: 0,
    label: "Custom Fields",
    description:
      "A separate custom field will be used for each relationship type. Fields will be multi-line text, with each item listed on a separate line."
  }
];

const onChangeUseKeywords = (value, dispatchLocal) => {
  dispatchLocal(syncSettingsOperations.setUseKeywordsForRelationships(Boolean(value)));
};

const onToggleKeywordType = (typeId, value, dispatchLocal) => {
  let actionCreator = value ? syncSettingsOperations.addKeywordType : syncSettingsOperations.removeKeywordType;
  dispatchLocal(actionCreator(typeId));
};

const onCustomFieldChange = (id, value, dispatchLocal) => {
  if (!value || value === SyncTypeOptions.NONE || value === SyncCustomFieldOptions.NONE) {
    // Selected None or Off, so remove sync field
    dispatchLocal(syncSettingsOperations.removeSyncField(id));
  } else {
    // Otherwise, customFieldId is the value passed in
    dispatchLocal(syncSettingsOperations.configureSyncField(id, value));
  }
};

const renderKeywordOptions = props => {
  const allowedKeywordTypes = typeSelectors.getSyncToEntityTypes(props.localStore);
  const selectedTypeIds = syncSettingsSelectors.getSyncKeywordTypes(props.localStore);

  const checkboxes = allowedKeywordTypes
    .map(t => {
      return (
        <FormCheckbox
          key={t.id}
          label={t.label}
          checkboxState={selectedTypeIds.has(t.id)}
          onChange={newState => onToggleKeywordType(t.id, newState, props.dispatchLocal)}
        />
      );
    })
    .toArray();

  return (
    <ModalGroup label="Sync Types to Keywords">
      <ModalRow>
        <ModalField>
          <ModalCheckboxGrid columns={2}>{checkboxes}</ModalCheckboxGrid>
        </ModalField>
      </ModalRow>
    </ModalGroup>
  );
};

const renderCustomFieldOptions = props => {
  const appName = syncSettingsSelectors.getSyncApplicationName(props.localStore);
  const allSyncTypeIds = syncSettingsSelectors.getSelectedSyncTypeSet(props.localStore);
  const allowedReferences = syncSelectors.getSyncKeywordReferenceOptionsForTypeIds(props.localStore, allSyncTypeIds);

  const entityFolderDropdowns = allowedReferences
    .map(r => (
      <ModalRow key={r.id} border={true} alignMiddle={true}>
        <ModalField flex={1}>
          <span>{r.label}</span>
        </ModalField>
        <ModalField flex={1}>
          <FormDropdown
            options={selectors.getOptionsForCustomFieldOfType(props.localStore, syncFieldTypes.MULTITEXT)}
            value={selectors.getCustomFieldIdForFieldId(props.localStore, r.id)}
            onChange={state => onCustomFieldChange(r.id, state, props.dispatchLocal)}
          />
        </ModalField>
      </ModalRow>
    ))
    .toArray();

  return (
    <ModalGroup label="Choose Folders">
      <ModalBlock>
        <ModalRow border={true} alignMiddle={true}>
          <ModalField flex={1}>
            <span style={{ opacity: 0.6 }}>Timeline Relationship</span>
          </ModalField>
          <ModalField flex={1}>
            <span style={{ opacity: 0.6 }}>{appName} Field</span>
          </ModalField>
        </ModalRow>
        {entityFolderDropdowns}
      </ModalBlock>
    </ModalGroup>
  );
};
const SyncRelationshipOptionsPage = props => {
  const useKeywords = syncSettingsSelectors.getSyncUseKeywordsForRelationships(props.localStore);

  return (
    <ModalBody key="content">
      <ModalTabContent>
        <div className="syncSettingsOptionsPage">
          <ModalGroup>
            <ModalRow>
              <ModalField label="Map relationships to" flex={1} />
              <ModalField flex={3}>
                <FormDropdown
                  options={mapToOptions}
                  value={useKeywords ? 1 : 0}
                  showDescription={true}
                  onChange={value => onChangeUseKeywords(Boolean(value), props.dispatchLocal)}
                />
              </ModalField>
            </ModalRow>
          </ModalGroup>
          {useKeywords ? renderKeywordOptions(props) : renderCustomFieldOptions(props)}
        </div>
      </ModalTabContent>
    </ModalBody>
  );
};

SyncRelationshipOptionsPage.propTypes = {
  localStore: PropTypes.object.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onDoneClick: PropTypes.func.isRequired
};

renderKeywordOptions.propTypes = SyncRelationshipOptionsPage.propTypes;
renderCustomFieldOptions.propTypes = SyncRelationshipOptionsPage.propTypes;

export default SyncRelationshipOptionsPage;
